import { NgIf, NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    ContentChild,
    EventEmitter,
    Input,
    Output,
    TemplateRef
} from '@angular/core';
import { ShIconComponent } from '../../elements/components/icon/icon.component';
import { IconSize } from '../../elements/components/icon/icon.module';
import { ContentContextNotificationsLayoutComponent } from '../content-context-notifications-layout/content-context-notifications-layout.component';

@Component({
    selector: 'sh-list-layout',
    templateUrl: './list-layout.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgIf, ShIconComponent, NgTemplateOutlet, ContentContextNotificationsLayoutComponent]
})
export class ListLayoutComponent {
    @Input() detailsCollapsed = true;
    @Input() filtersCollapsed = false;
    @Input() hierarchyCollapsed = false;

    @Output() toggleFilters: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() toggleHierarchy: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ContentChild('filtersContent') filtersContent: TemplateRef<any>;
    @ContentChild('filtersCollapsedContent') filtersCollapsedContent: TemplateRef<any>;

    @ContentChild('hierarchyContent') hierarchyContent: TemplateRef<any>;
    @ContentChild('hierarchyCollapsedContent') hierarchyCollapsedContent: TemplateRef<any>;

    @ContentChild('detailContent') detailContent: TemplateRef<any>;
    @ContentChild('detailEmphasisedContext') detailEmphasisedContext: TemplateRef<any>;
    @ContentChild('detailContext') detailContext: TemplateRef<any>;

    @ContentChild('mainContent') mainContent: TemplateRef<any>;
    @ContentChild('mainContentEmphasisedContext') mainContentEmphasisedContext: TemplateRef<any>;
    @ContentChild('mainContentContext') mainContentContext: TemplateRef<any>;

    public IconSize: typeof IconSize = IconSize;

    public onToggleFilters(e: MouseEvent): void {
        this.toggleFilters.emit(!this.filtersCollapsed);
    }

    public onToggleRecordTree(e: MouseEvent): void {
        this.toggleHierarchy.emit(!this.hierarchyCollapsed);
    }
}
